<template>
  <div class="header-container" v-kiosk>
    <div>{{ title }}</div>
  </div>
</template>
<script>
export default {
  props: ["title"],
};
</script>
<style lang="scss" scoped>
.header-container {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
</style>
